import { get } from 'lodash';

export default function coverageOptionStrToNum(str: string | null | undefined) {
  return str ? Number(get(str.match(/\d+/), 0, 0)) : 0;
}
